import { render } from "./QueueDisplay.vue?vue&type=template&id=1985087c"
import script from "./QueueDisplay.vue?vue&type=script&lang=js"
export * from "./QueueDisplay.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__